import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { push, replace } from 'react-router-redux';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { serverRequestPost } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { fetchAddressSettings } from '../../actions/addressSettings';
import NavBar from '../../components/NavBar';
import Form from './Form';

class New extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    token: PropTypes.string,
    loading: PropTypes.bool,
    onCheck: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    this.state = {
      hasChanges: false,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    if (
      !this.props.auth.isSuperAdmin &&
      !this.props.auth.isHeadquarters &&
      !this.props.auth.isBranchLeaderSupervisorII
    ) {
      store.dispatch(replace('/forbidden/'));
      return;
    }
    store.dispatch(fetchAddressSettings());
  }
  addBankAccount(projectId, value) {
    const attr = {
      bank: value.bank,
      accountNumber: value.accountNumber,
      isActive: value.isActive,

    };
    const { store } = this.context;
    return serverRequestPost(
      `/projects/${projectId}/bank_accounts/`,
      store,
      this.props.token,
      attr,
    );
  }
  addCurrency(projectId, value) {
    const attr = {
      code: value.code,
      conversionRatePoint: value.conversionRatePoint,
      isDefault: value.isDefault,
      name: value.name,
    };
    const { store } = this.context;
    return serverRequestPost(
      `/projects/${projectId}/currency/`,
      store,
      this.props.token,
      attr,
    );
  }
  async handleError(store, msg, errorObj, isBugsnag = false) {
    await store.dispatch(flashErrorMessage({ message: msg }));
    if (isBugsnag) Bugsnag.notifyException(errorObj);
  }
  async submit(validations, project) {
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    const projectCurrency = project.projectCurrency || [];
    const projectBankAccount = project.projectBankAccount || [];
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: i18next.t('Please fix form errors', { ns: 'translation' }), list: errors.map(l => l.message).filter((m, idx, arr) => arr.indexOf(m) === idx) }));
      return;
    }
    let res;
    try {
      res = await this.form.getWrappedInstance().getWrappedInstance().submit('/projects/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(project),
      });
    } catch (err) {
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false, async (noChanges) => {
        if (noChanges) {
          const promiseArr = [
            projectCurrency.map(c => this.addCurrency(res.id, c)),
            projectBankAccount.map(c => this.addBankAccount(res.id, c)),
          ];
          if (promiseArr.length > 0) {
            const promiseResultArray = await Promise.all(promiseArr);
            const noError = promiseResultArray.every(response => response.error === false);
            if (!noError) {
              this.handleError(store, i18next.t('An error occurred, please refresh page', { ns: 'translation' }));
            }
          }
          store.dispatch(push(`/projects/${res.id}/`));
          store.dispatch(flashSuccessMessage({ header: i18next.t('Create Success', { ns: 'translation' }), message: i18next.t('{{name}} successfully created', { ns: 'translation', name: res.name }) }));
        }
      });
    });
  }
  handleSubmit = (event) => {
    this.form.getWrappedInstance().getWrappedInstance().handleSubmit(event);
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  render() {
    return (
      <Container>
        <NavBar
          header={i18next.t('New', { ns: 'constants' })}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={i18next.t('Create', { ns: 'translation' })}
                onClick={this.handleSubmit}
                disabled={!this.state.hasChanges}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, project) => {
            this.submit(validations, project);
          }}
          onChange={this.handleOnChange}
          loading={this.props.loading}
          auth={this.props.auth}
        />
      </Container>
    );
  }
}

export default connect(New.mapStateToProps)(New);



// WEBPACK FOOTER //
// ./src/containers/Projects/New.jsx